<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import { slide } from "svelte/transition";
  import type { StoresKey } from "~/stores";
  import LunchFilter from "../lunch/LunchFilter.svelte";
  import PreParagraphText from "~/components/fragment-sets/common/PreParagraphText.svelte";
  import { dayOfTheWeek, getSomeDaysOfTheWeek, parseLunchMenuDate } from "~/util/date-n-time";
  import type { ManageAPI } from "~/manage-api/types";

  export let request_store_key: StoresKey;

  const { store, locale, lunch, T } = getStoresContext(request_store_key);

  type DayLunch = ManageAPI.DailyLunchMenu & { day_of_the_week: number };

  let activeDay = dayOfTheWeek();
  let showLunch = true;
  let serves_lunch: ManageAPI.Lunch | undefined;
  let serves_lunch_days: DayLunch[] = [];

  $: if ($store && $lunch) {
    serves_lunch = $lunch.find((lunch) => lunch.store.id == $store?.id);
  }

  $: serves_lunch_days = serves_lunch?.dailyLunchMenus.map(x => ({
    ...x,
    day_of_the_week: parseLunchMenuDate(x.day).getDay()
  })) || [];

  $: lunch_of_the_day = serves_lunch_days.find(
    x => x.day_of_the_week == activeDay)?.lunchMenu || "";

  $: weekdays = !serves_lunch ? [] : 
    getSomeDaysOfTheWeek($locale, serves_lunch_days.map(x => x.day_of_the_week));

  $: t = $T;

  function changeActiveDay(event: CustomEvent): string {
    return (activeDay = event.detail);
  }

  function toggle () { showLunch = !showLunch; }
</script>

{#if serves_lunch}
  <div class="mb-7 pr-lg-5 pr-0">
    <div class="mb-4" role="tablist">
      <div class="row"
        role="tab"
        aria-controls="lunch-panel"
        aria-selected={showLunch}
        on:click={toggle}
        on:keyup={toggle}
        tabindex="0">
        <h2 class="storeSectionTitle col-10">{t`lunch today`}</h2>
        <div class="col-2 text-right">
          <button class="toggle">
            <img
              src="/theme/citycon2023/images/arrow-down-black.png"
              alt="arrow-down-black"
              class:up={showLunch}
              width="32" />
          </button>
        </div>
      </div>
    </div>
    {#if showLunch}
      <div class="row" transition:slide|local id="lunch-panel">
        <div class="col-12">
          <LunchFilter {request_store_key} {weekdays}
            on:changeActiveDay={changeActiveDay} />
        </div>
        <div class="col-12">
          <div class="border-dark">
            <p>{t`lunch time`}: {serves_lunch?.lunchTime}</p>
            {#if serves_lunch?.generalInformation}
              <p>{serves_lunch?.generalInformation}</p>
            {/if}
            <PreParagraphText text={lunch_of_the_day} />
          </div>
        </div>
      </div>
    {/if}
  </div>
{/if}

<style lang="scss">
  .toggle {
    background-color: transparent;
    border: none;
    img {
      transition: all 0.45s;
    }
  }
  .toggle .up {
    transform: rotate(180deg);
  }
  .border-dark {
    border: 1px solid #000;
    border-top: 0;
    padding: 24px 16px;

    @media screen and (min-width: 992px) {
      padding: 48px 64px;
    }
  }
</style>
